import React, { useEffect, useState } from "react";
import XenieNewLogo from "../../Assets/XenieNewLogo.svg";
// import prada from "../../Assets/Account/prada-logo 2.svg";
import eyeOff from "../../Assets/eyeIconOff.svg";
import eye from "../../Assets/eye.svg";
import { useNavigate, Link } from "react-router-dom";
import correctIcon from "../../Assets/correct.svg";
import UserIcon from "../../Assets/Lens/user.svg";
import ChevronDown from "../../Assets/ChevronDownLargeDarkMode.svg";
import useAuthentication from "../../Hooks/useAuthentication";
import CustomButton from "../Buttons/CustomButton";
import { sanitizeToPositiveInteger } from "../../lib/utils/utils";

export default function MemberSignUp() {
  const [type1, setType1] = React.useState("password");
  const [type2, setType2] = React.useState("password");
  const [icon1, setIcon1] = React.useState(eyeOff);
  const [icon2, setIcon2] = React.useState(eyeOff);
  const [formErrors, setFormErrors] = useState({
    password: "",
    confirmPassword: "",
  });
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [isChecked, setIsChecked] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [sellerId, setSellerId] = React.useState("");
  const [storeImage, setStoreImage] = React.useState("");
  const [storeName, setStoreName] = React.useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const { setAuthenticated } = useAuthentication();

  const handleToggle1 = () => {
    setType1(type1 === "password" ? "text" : "password");
    setIcon1(type1 === "password" ? eye : eyeOff);
  };

  const handleToggle2 = () => {
    setType2(type2 === "password" ? "text" : "password");
    setIcon2(type2 === "password" ? eye : eyeOff);
  };

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    const isValid = validatePassword(newPassword);

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      password: isValid
        ? ""
        : "Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 numeric character, 1 special character, and be at least 8 characters long.",
    }));
  };

  const handlePhoneNUmber = (e) => {
    const value = e.target.value;
    const cleanedValue = sanitizeToPositiveInteger(value);
    setPhone(cleanedValue);
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
  };

  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match.",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }
  }, [password, confirmPassword]);

  const navigate = useNavigate();

  const handleSubmitForm = async () => {
    setIsLoading(true);
    const data = {
      name,
      email,
      SellerUserId: sellerId,
      phoneNumber: phone,
      password,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}v1/sellerMembers/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Something went wrong: ${errorData.message}`);
      }
      if (response.ok) {
        const result = await response.json();
        setAuthenticated(result.data.accessToken, result.data.refreshToken);
        const roles = result.data.role;
        if (roles?.includes("Admin")) {
          navigate("/");
          window.location.reload();
        } else if (roles?.includes("Store Manager")) {
          navigate("/storefront");
          window.location.reload();
        } else if (roles?.includes("Inventory Manager")) {
          navigate("/inventory-management");
          window.location.reload();
        } else if (roles?.includes("Lens Manager")) {
          navigate("/lens-and-reviews");
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("Failed to post data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const isPhoneValid = phone.trim().length === 10 && /^\d+$/.test(phone);
    const doPasswordsMatch = password === confirmPassword;

    const isFormValid =
      name.trim() &&
      isPhoneValid &&
      password.trim() &&
      confirmPassword.trim() &&
      doPasswordsMatch &&
      isChecked;

    setIsDisabled(!isFormValid);
  }, [name, phone, password, confirmPassword, isChecked]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const memberId = urlParams.get("email");
    const sellerId = urlParams.get("brand");
    setSellerId(sellerId);
    async function fetchEmail() {
      try {
        const url = `${process.env.REACT_APP_API_URL}v1/verifyEmail/extractToken/${sellerId}/${memberId}`;
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          setEmail(data.data.memberEmail);
          setStoreImage(data.data.storeImg);
          setStoreName(data.data.storeName);
        } else {
          console.error("Failed to fetch data from API");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (memberId && sellerId) {
      fetchEmail();
    } else {
      console.error("data is not found in the URL");
    }
  }, []);

  return (
    <React.Fragment>
      <div className="w-full flex overflow-hidden">
        <div className="w-[40%] h-[100vh] bg-blue1f fixed top-0 left-0">
          <div className="w-full p-10 h-[68px] flex justify-start">
            <div className="h-11 w-auto">
              <img
                className="h-full w-auto mx-auto"
                src={XenieNewLogo}
                alt="Xenie Logo"
              />
            </div>
          </div>
          <div className="flex flex-col gap-6 items-center justify-center h-full">
            <div className="w-[100px] h-[100px] overflow-hidden flex items-center justify-center rounded-full bg-black12 border border-solid border-greyea">
              {storeImage ? (
                <img src={storeImage} alt="" className="rounded-full" />
              ) : (
                <div className="bg-[#666666] size-full">
                  <img className="size-full" src={UserIcon} alt="" />
                </div>
              )}
            </div>
            <div className="text-[20px] leading-[24px] font-semibold text-whiteff text-center">
              You are invited to join the {storeName}'s Seller Account.
            </div>
          </div>
        </div>
        <div className="w-[60%] pl-[21px] pt-10 pb-10 absolute top-0 right-0">
          <div className="pb-[38px] text-[32px] font-semibold">
            Create an account
          </div>
          <div className="pl-[115px] w-[77%]">
            <div className="text-[24px] leading-[32px] font-semibold pb-2">
              Basic Information
            </div>
            <form action="submit">
              <div className="pb-4">
                <div className="text-14px leading-6 font-medium pb-2">
                  <label htmlFor="name">Enter Full Name</label>
                </div>
                <div className="">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="enter full name"
                    autoComplete="off"
                    className="input-fieldBussiness"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
              <div className="pb-4">
                <div className="text-14px leading-6 font-medium pb-2">
                  <label htmlFor="email">Email Address</label>
                </div>
                <div className="">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    placeholder="enter email address"
                    readOnly
                    autoComplete="off"
                    className="input-fieldBussiness"
                    value={email}
                  />
                </div>
              </div>
              <div className="pb-4">
                <div className="text-14px leading-6 font-medium pb-2">
                  <label htmlFor="phone">Phone Number</label>
                </div>

                <div className="w-full border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-lg flex items-center gap-2">
                  <p className="size-6 font-normal text-base text-[#666666]">
                    +91
                  </p>

                  <div className="size-6 flex items-center justify-center">
                    <img src={ChevronDown} alt="" />
                  </div>

                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    autoComplete="off"
                    className="w-[calc(100%-24px-24px)] bg-transparent outline-none font-normal text-base placeholder:text-[#666666] text-[#000000]"
                    placeholder="enter phone number"
                    value={phone}
                    maxLength={10}
                    onChange={handlePhoneNUmber}
                  />
                </div>
              </div>
              <div className="basicInfoFormInput">
                <div>
                  <label htmlFor="password" className="basicInfoFormLabel">
                    Password
                  </label>
                  <input
                    type={type1}
                    id="password"
                    name="password"
                    placeholder="enter password"
                    autoComplete="off"
                    className="input-fieldBussiness"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <span
                    className="eyeIconParentRegistration"
                    onClick={handleToggle1}
                  >
                    <img className="eyeIcon" src={icon1} size={25} alt="" />
                  </span>
                </div>
              </div>
              {formErrors.password && (
                <div className="text-[12px] leading-[20px] text-redef">
                  {formErrors.password}
                </div>
              )}
              <div className="basicInfoFormInput">
                <label htmlFor="confirmpassword" className="basicInfoFormLabel">
                  Confirm Password
                </label>
                <input
                  type={type2}
                  id="confirmpassword"
                  name="confirmPassword"
                  placeholder="confirm password"
                  className="input-fieldBussiness"
                  autoComplete="off"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                <span
                  className="eyeIconParentRegistration"
                  onClick={handleToggle2}
                >
                  <img className="eyeIcon" src={icon2} size={25} alt="" />
                </span>
              </div>
              {formErrors.confirmPassword && (
                <div className="text-[12px] leading-[20px] text-redef">
                  {formErrors.confirmPassword}
                </div>
              )}
              <div className="pb-8">
                <div className="flex gap-2 items-center">
                  <span
                    onClick={() => setIsChecked(!isChecked)}
                    className="cursor-pointer"
                  >
                    <div className={`newbox ${isChecked ? "checked" : ""}`}>
                      {isChecked && <img src={correctIcon} alt="Checked" />}
                    </div>
                  </span>
                  <span>
                    I agree that I have read and accepted the{" "}
                    <Link
                      className="terms text-link font-semibold"
                      to="/terms-and-conditions"
                      target="_blank"
                    >
                      terms and conditions
                    </Link>
                  </span>
                </div>
              </div>
            </form>

            <CustomButton
              title="Register"
              className="w-full"
              disabled={isDisabled}
              loading={isLoading}
              onClick={handleSubmitForm}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
